import Client from 'shopify-buy/index.unoptimized.umd';

function createCustomerAccessTokenCreateMutation (shopifyClient) {
  const input = shopifyClient.graphQLClient.variable('input', 'CustomerAccessTokenCreateInput!');
  const customerAccessTokenCreateMutation = shopifyClient.graphQLClient.mutation('customerAccessTokenCreate', [input], (root) => {
    root.add('customerAccessTokenCreate', { args: { input } }, (customerAccessTokenCreate) => {
      customerAccessTokenCreate.add('customerAccessToken', (customerAccessToken) => {
        customerAccessToken.add('accessToken');
      });
    });
  });

  return (input) => {
    return shopifyClient.graphQLClient.send(customerAccessTokenCreateMutation, { input }).then(({ model, data }) => {
      return data;
    });
  };
}

function createCheckoutCustomerAssociateV2Mutation (shopifyClient) {
  const checkoutId = shopifyClient.graphQLClient.variable('checkoutId', 'ID!');
  const customerAccessToken = shopifyClient.graphQLClient.variable('customerAccessToken', 'String!');

  const mutation = shopifyClient.graphQLClient.mutation('checkoutCustomerAssociateV2', [checkoutId, customerAccessToken], (root) => {
    root.add('checkoutCustomerAssociateV2', { args: { checkoutId, customerAccessToken } }, (checkoutCustomerAssociateV2) => {
      checkoutCustomerAssociateV2.add('checkout', (checkout) => {
        checkout.add('id');
      });
      checkoutCustomerAssociateV2.add('customer', (customer) => {
        customer.add('id');
      });
    });
  });

  return (input) => {
    return shopifyClient.graphQLClient.send(mutation, input).then(({ model, data }) => {
      return data;
    });
  };
}

export default {
  setup: function () {
    let domain = '';
    let storefrontAccessToken = '';
    // eslint-disable-next-line no-undef
    if (typeof config !== 'undefined' && config.env === 'prod') {
      domain = 'preventia.myshopify.com';
      storefrontAccessToken = '4e88d82dc2d3c61e0be111026db59dcb';
    } else {
      domain = 'prevenitatest.myshopify.com';
      storefrontAccessToken = '4f22db1e2870796284efa7895cab7f1a';
    }

    const shopifyClient = Client.buildClient({
      domain,
      storefrontAccessToken
    });

    shopifyClient.customerAccessTokenCreate = createCustomerAccessTokenCreateMutation(shopifyClient);
    shopifyClient.createCheckoutCustomerAssociateV2 = createCheckoutCustomerAssociateV2Mutation(shopifyClient);
    return shopifyClient;
  }
};
